<ng-template #showBenefitDetail let-modal>
    <div class="modal-body" *ngIf="selectedBenefit">

        <div>
            <!-- Imagen -->  
            <div class="d-flex-center">
            <img *ngIf="selectedBenefit.type == 'giftcard'" [src]="selectedBenefit.data.thumbnailUrl" class="img-pop">
            <img *ngIf="selectedBenefit.type == 'coupon'" [src]="selectedBenefit.data.thumbnailUrl" class="img-coupon">
            <img *ngIf="selectedBenefit.type == 'event' || selectedBenefit.type == 'pass' || selectedBenefit.type == 'cashless'" [src]="selectedBenefit.data.thumbnailUrl" class="img-event">
            <img *ngIf="selectedBenefit.type == 'scratch'" [src]="selectedBenefit.data.thumbnailUrl" class="img-scratch">
            </div>          


            <!-- Descriptions -->
            <div class="text-center m-t-24">
                <div class="text-center font-b1">
                    <b>{{selectedBenefit.data.name}} </b> <b *ngIf="selectedBenefit.type == 'giftcard'"> {{selectedBenefit.data.price | currency: selectedBenefit.data?.vendor?.currencySymbol : 'symbol': '1.0'}}</b> 
                </div>
                <div class="text-center mt-2">                    
                    <div class="font-c1" [innerHTML]="selectedBenefit.data.description"></div>
                </div>
            </div>

            <!-- Validez -->
            <div class="d-flex align-items-center m-t-20 font-c1 font-bold border-top pt-3 pb-3" *ngIf="selectedBenefit.type == 'coupon' || selectedBenefit.type == 'event'">
                <i class="mdi mdi-clock-alert text-purple mr-2"></i>
                Válidez:
            </div>
            <div class="d-flex font-c1" *ngIf="selectedBenefit.type == 'coupon' || selectedBenefit.type == 'event'">
                Este beneficio es válido hasta el {{selectedBenefit.data.endDateAt | date: 'dd/MMM/yyyy - h:mm a'}}
            </div>

            <!-- Condiciones -->
            <div class="d-flex align-items-center m-t-20 font-c1 font-bold border-top pt-3 pb-3" 
            *ngIf="selectedBenefit.type == 'coupon' || selectedBenefit.type == 'event' && selectedBenefit.data.terms">
                <i class="mdi mdi-file-document text-purple mr-2"></i>
                Condiciones:
            </div>
            <div *ngIf="selectedBenefit.type == 'coupon' || selectedBenefit.type == 'event'" class="font-c1" [innerHTML]="selectedBenefit.data.terms"></div>

            <!-- canjeable -->
            <div *ngIf="selectedBenefit.data.stores">
                <app-smart-list-store [stores]="selectedBenefit.data.stores"></app-smart-list-store>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
            <div class="font-16 text-muted"  (click)="closeModal()">Cerrar</div>
        </div>
    </div>
</ng-template>